import { Entity, mapEntity, SnakeMetaResponseV2 } from '@toggle/toggle';

import {
  LatestValues,
  ReturnValue,
  WatchlistEntities,
} from './watchlist-types';

type MapEntityValuesProps = {
  entities: WatchlistEntities[];
  entity: Entity;
  latestValues: LatestValues;
  snakeMeta: SnakeMetaResponseV2;
  tag: string;
};

export const mapEntityValues = ({
  entities,
  entity,
  snakeMeta,
  tag,
  latestValues,
}: MapEntityValuesProps): WatchlistEntities[] => {
  const formatReturn = (value?: {
    last_value: number;
    last_value_formatted: string;
    last_update: string;
  }): ReturnValue => {
    return value
      ? {
          value: value.last_value,
          formattedValue: value.last_value_formatted,
        }
      : { value: 0, formattedValue: '-' };
  };

  const getPrices = () => {
    const meta = snakeMeta[entity.default_snake];

    if (!meta) {
      return undefined;
    }

    return {
      last_value: meta.last_value,
      before_last_value: meta.before_last_value,
    };
  };

  const mapReturns = () => ({
    rsi: formatReturn(latestValues['price_rsi(horiz=14d)']),
    return1D: formatReturn(latestValues['mom(horiz=1d)']),
    return1W: formatReturn(latestValues['mom(horiz=1w)']),
    return1M: formatReturn(latestValues['mom(horiz=1m)']),
    return3M: formatReturn(latestValues['mom(horiz=3m)']),
    return6M: formatReturn(latestValues['mom(horiz=6m)']),
    return1Y: formatReturn(latestValues['mom(horiz=12m)']),
    peTrailing: formatReturn(latestValues['pe_ibes_trailing_12m']),
    peForward: formatReturn(latestValues['pe_ibes_forward_12m']),
  });

  return entities.map(e => {
    const meta = snakeMeta[entity.default_snake];
    const displayFormat = meta?.display_format
      ? meta.display_format
      : undefined;

    if (e.tag === tag) {
      return {
        ...e,
        asset: mapEntity(entity),
        returns: mapReturns(),
        prices: getPrices(),
        displayFormat: displayFormat,
        isLoading: false,
      };
    }

    return e;
  });
};
